import React, { useState } from 'react';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Firestore se check karein ki user sach mein admin hai ya nahi
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists() && userSnap.data().isAdmin === true) {
        navigate('/admin'); // Sirf admin ko hi dashboard milega
      } else {
        // Agar normal user hai, toh access deny karke logout kar do
        await signOut(auth);
        setError('Access Denied! Only administrators can login through this portal.');
      }
    } catch (err) {
      setError('Invalid admin credentials. Please check your email and password.');
      try { await signOut(auth); } catch (_) {}
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4 font-sans">
      <div className="max-w-md w-full bg-slate-900 border border-slate-800 p-8 rounded-3xl shadow-2xl text-white">
        
        <div className="text-center mb-8">
          <span className="bg-rose-500/20 text-rose-400 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider">
            Restricted Area
          </span>
          <h2 className="text-2xl font-extrabold mt-3 text-slate-100">Admin Portal Login</h2>
          <p className="text-slate-400 text-xs mt-1">Enter your admin credentials to manage property listings</p>
        </div>

        {error && (
          <div className="mb-6 p-3 bg-rose-500/20 border border-rose-500/40 text-rose-300 rounded-xl text-xs text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleAdminLogin} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-400 uppercase mb-1">Admin Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
              placeholder="admin@primiumflats.com"
              className="w-full bg-slate-800 border border-slate-700 text-white px-4 py-3 rounded-xl text-sm focus:outline-none focus:border-rose-500"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-400 uppercase mb-1">Password</label>
            <div className="relative">
              <input 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
                placeholder="••••••••"
                className="w-full bg-slate-800 border border-slate-700 text-white px-4 py-3 rounded-xl text-sm focus:outline-none focus:border-rose-500 pr-16"
              />
              <button 
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white text-xs font-semibold bg-slate-700 px-2.5 py-1 rounded-lg transition"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-rose-600 hover:bg-rose-700 text-white py-3.5 rounded-xl font-semibold transition disabled:opacity-50 text-sm shadow-lg mt-2"
          >
            {loading ? "Authenticating..." : "Login as Admin"}
          </button>
        </form>

        <div className="mt-8 text-center border-t border-slate-800 pt-4">
          <Link to="/login" className="text-xs text-slate-400 hover:text-slate-200 transition">
            &larr; Back to Customer Login
          </Link>
        </div>

      </div>
    </div>
  );
}